module.exports = __webpack_public_path__ + "static/img/gongshang.5bf7f093.png";